/* eslint-disable import/no-unresolved,import/extensions */
import projectionGridImport from 'projection-grid';
import SummaryDataContextManagerImport from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import ConstantsImport from '@bingads-webui-campaign-react/ui-next/src/legacy-dep-bootstrap/shim/Constants';
import * as PageReadyPkg from '@bingads-webui/page-ready';
import * as newEDM from '@bingads-webui/edm-core';
import * as EDMCampaign from '@bingads-webui/edm-campaign';
import legacyRouterImport from '@bingads-webui-campaign-react/ui-next/src/legacy-dep-bootstrap/shim/legacy-router';
import * as cacheManager2Import from '@bingads-webui-campaign/campaign-cache-manager';
import cacheManagerImport from '@bingads-webui-campaign-legacy/cache-manager/index';
import edmImport from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataStorageImport from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import exRepoImport from '@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository';
import legacyOdataImport from '@bingads-webui-component-legacy/http/channel/odata';
import legacyPreferenceImport from '@bingads-webui-component-legacy/preference/service/index';
import componentStateImport from '@bingads-webui-component-legacy/state/index';
import jsDataCampaignImport from '@bingads-webui-component-legacy/js-data-campaign/index';
import eventDispatcherImport from '@bingads-webui-component-legacy/event-dispatcher/index';
import hotelCenterJsDataImport from '@bingads-webui-campaign-legacy/hotel-center-js-data/index';
import hotelCenterEDMImport from '@bingads-webui-campaign-legacy/hotel-center-edm/index';
import * as azurePayloadImport from '@bingads-webui/azure-upload';

/* eslint-enable */

const legacyPreference = legacyPreferenceImport;
const legacyOdata = legacyOdataImport;
const jsDataStorage = jsDataStorageImport;
const Constants = ConstantsImport;
const pageReadyFromWebPack = PageReadyPkg;
const projectionGrid = projectionGridImport;
const legacyRouter = legacyRouterImport;
const state = componentStateImport;
const cacheManager = cacheManagerImport;
cacheManager.default = cacheManagerImport;
const cacheManager2 = cacheManager2Import;
const newEdm = newEDM;
const edmCampaign = EDMCampaign;
const edm = edmImport;
edm.default = edm;
const jsDataCampaign = jsDataCampaignImport;
jsDataCampaign.default = jsDataCampaign;
const SummaryDataContextManager = SummaryDataContextManagerImport;
SummaryDataContextManager.default = SummaryDataContextManager;
const eventDispatcher = eventDispatcherImport;
eventDispatcher.default = eventDispatcher;
const hotelCenterJsData = hotelCenterJsDataImport;
const hotelCenterEDM = hotelCenterEDMImport;
hotelCenterEDM.default = hotelCenterEDM;
const azurePayload = azurePayloadImport;

define('@bingads-webui/page-ready', [], () => pageReadyFromWebPack);

define('projection-grid', [], () => projectionGrid);
define('@bingads-webui-component-legacy/github/node_modules/projection-grid/dist/projection-grid', [], () => projectionGrid);
define('component/github/node_modules/projection-grid/dist/projection-grid', [], () => projectionGrid);

define('@bingads-webui-component-legacy/schema-campaign/override/orphans/Setting', [], () => ({}));
define('component/schema-campaign/override/orphans/Setting', [], () => ({}));

define('@bingads-webui-component-legacy/schema-vnext/singleton', [], () => ({
  default: {
    getRawSchema: () => {},
    getSchema: () => {},
  },
}));

define('component/schema-vnext/singleton', [], () => ({
  default: {
    getRawSchema: () => {},
    getSchema: () => {},
  },
}));

define('@bingads-webui-component-legacy/legacy-router/index', [], () => legacyRouter);
define('component/legacy-router/index', [], () => legacyRouter);

define('@bingads-webui-static-legacy/constants', [], () => Constants);
define('Constants', [], () => Constants);

// TODO: these can be removed from RJS bundles, or just wait for RJS bundles to be removed completely
define('@bingads-webui-component-legacy/state/index', [], () => state);
define('component/state/index', [], () => state);

define('@bingads-webui-component-legacy/js-data-storage/session-storage', [], () => {
  jsDataStorage.default = jsDataStorage;

  return jsDataStorage;
});

define('component/js-data-storage/session-storage', [], () => {
  jsDataStorage.default = jsDataStorage;

  return jsDataStorage;
});

define('@bingads-webui-campaign-legacy/cache-manager/index', [], () => cacheManager);
define('@bingads-webui-campaign/campaign-cache-manager', [], () => cacheManager2);
window.dataContextManagerAvailable = false;
const contextManagerShim = () => {
  window.dataContextManagerAvailable = true;

  return SummaryDataContextManager;
};
define('@bingads-webui-static-legacy/summary/SummaryDataContextManager', [], contextManagerShim);
define('@bingads-webui-component-legacy/edm-campaign/index', [], () => edm);
define('@bingads-webui-component-legacy/js-data-campaign/index', [], () => jsDataCampaign);
define('@bingads-webui-component-legacy/event-dispatcher/index', [], () => eventDispatcher);
define('@bingads-webui/edm-core', [], () => newEdm);
define('@bingads-webui/edm-campaign', [], () => edmCampaign);
const exRepo = exRepoImport;
exRepo.default = exRepo;

define('@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository', [], exRepo);
define('@bingads-webui-component-legacy/http/channel/odata', [], legacyOdata);
define('@bingads-webui-component-legacy/preference/service/index', [], { default: legacyPreference, __esModule: true });
define('@bingads-webui-campaign-legacy/hotel-center-js-data/index', [], () => hotelCenterJsData);
define('@bingads-webui-campaign-legacy/hotel-center-edm/index', [], () => hotelCenterEDM);
define('@bingads-webui/azure-upload', [], () => azurePayload);


define('campaignui/feature/cache-manager/index', [], () => cacheManager);
define('Summary/SummaryDataContextManager', [], contextManagerShim);
define('component/edm-campaign/index', [], () => edm);
define('component/js-data-campaign/index', [], () => jsDataCampaign);
define('component/event-dispatcher/index', [], () => eventDispatcher);

define('campaignui/feature/advanced-settings/util/exclusion-repository', [], exRepo);
define('component/http/channel/odata', [], legacyOdata);
define('component/preference/service/index', [], { default: legacyPreference, __esModule: true });
define('campaignui/feature/hotel-center-js-data/index', [], () => hotelCenterJsData);
define('campaignui/feature/hotel-center-edm/index', [], () => hotelCenterEDM);
